export const WorkerUrl = {
  PROD: "https://cloudflare.carbonhealth.com",
  STAGING: "https://cloudflare.alpha.carbonhealth.com",
  LOCAL: "http://localhost:8787",
} as const;
